import React, { useEffect, useState } from 'react';
import { UitkButtonSize } from 'uitk-react-button';
import { css } from 'styled-components';
import gaLogger from 'src/utils/ga-logger';

//components
import SiimpleMenu from 'src/components/common/modules/global-header/simple-menu/simple-menu';
import SubLevelMenu from 'src/components/common/modules/global-header/sub-level-menu/sub-level-menu';
import Layout from 'src/components/common/theme/Layout';
import { UitkText } from 'uitk-react-text';
import { HeaderBrandLogo, HeaderBrandLogoProps } from 'src/components/common/modules/header-brand-logo/brand-logo';
import { SecondaryButton, SecondaryButtonProps } from 'src/components/common/ui/button/button';
import { SubHeaderProps } from '../global-header.d';
import LozengeMessageV2 from 'src/components/common/modules/global-header/lozenge-message/lozenge-message-v2';
import { BurgerMenu } from 'src/components/common/modules/global-header/burger-menu/burger-menu';

//helpers
import { checkValue, onImageLoadWithoutCache } from 'src/components/common/helper';
import { LozengeMessageV2Props } from 'src/components/common/module-util';
import { useStores } from 'src/utils/useStore';
import { UitkLink } from 'uitk-react-link';
import { getStore } from 'src/utils/store-utils';

const SubHeader: React.FC<SubHeaderProps> = (props) => {
  const { context } = useStores();
  const { subHeaderMenuPosition, partnerHeaderSubNavigation } = getStore();
  const siteBrand = context?.site?.brand;
  const headerBrandLogoProps: HeaderBrandLogoProps = {
    altText: props?.partnerLogoAltText,
    imgSrc: onImageLoadWithoutCache(props?.partnerLogo, true),
    href: props?.partnerUrl,
    exClass: `partner-logo ${props?.partnerHeaderSize}`,
    areaLabel: props?.partnerLogoAltText,
    title: props?.partnerName,
    partnerLogoAltText: props?.partnerLogoAltText,
    gaTracking: {
      eventCategory: 'logo click',
      eventAction: 'Partner Header',
      eventLabel: props?.partnerUrl,
    },
    onClickEvent: () => logoOnclick(),
    onKeyPressEvent: () => logoOnclick(),
    target: props?.openPartnerUrlInSameTab ? '_self' : '_blank',
  };

  const scrollToHashElement = (elem, offset = 0) => {
    const elementToScroll = elem;
    if (!elementToScroll) return;
    const header_section = (document.querySelector('.header-main-container') as HTMLElement) || null;
    const headerOffSet = checkValue(header_section) ? header_section.offsetHeight : 0;
    const scrollY = window?.scrollY;
    const elementTop = elementToScroll?.getBoundingClientRect()?.top;

    const elementScrollAmount = Number(elementTop + scrollY);
    const scrollTop = Number(elementScrollAmount) - Number(headerOffSet) - Number(offset);
    window.scrollTo({
      top: scrollTop,
      behavior: 'smooth',
    });
  };

  const handleScroll = () => {
    const elm = document.getElementById(siteBrand === 'vrbo' ? 'lodging-search-form' : 'search-booking-wizard-module');

    if (checkValue(elm)) {
      setTimeout(() => {
        scrollToHashElement(elm, 0);
      }, 1000);
    }
  };

  const secondaryButtonProps: SecondaryButtonProps = {
    text: props?.partnerCtaText,
    tag: 'button',
    gaTracking: {
      eventCategory: 'Button Click',
      eventAction: 'Partner Sub header CTA Click',
      eventLabel: `${props?.partnerCtaText} - ${props?.partnerCtaUrl}`,
    },
    exClass: `partner-header-action ga4-partner-header-shop-btn`,
    ...(checkValue(props?.partnerCtaUrl)
      ? {
          url: props?.partnerCtaUrl,
          target: '_blank',
        }
      : {
          onClickEvent: () => handleScroll(),
        }),
    size: UitkButtonSize.LARGE,
  };

  const moduleCss = () => {
    const ctaHoverBgColor = checkValue(props?.partnerCtaHoverColor)
      ? props?.partnerCtaHoverColor
      : props?.partnerCtaColor;
    const ctaHoverFontColor = checkValue(props?.partnerCtaHoverTextColor)
      ? props?.partnerCtaHoverTextColor
      : props?.partnerCtaTextColor;
    return `
    ${
      checkValue(props?.partnerHeaderBackgroundColor)
        ? `
      &.partner-header-region {
        background-color: ${props?.partnerHeaderBackgroundColor} !important;
      }
      .partner-header-action {
        &:hover {
          color:${props?.partnerHeaderBackgroundColor} !important;
        }
      }
  `
        : ''
    }
    ${
      checkValue(props?.partnerHeaderTextColor)
        ? `
      &.partner-header-region {
        color:${props?.partnerHeaderTextColor.toLowerCase() === 'dark' ? '#141D38' : '#ffffff'} !important;
      }
  `
        : ''
    }
    ${
      checkValue(props?.partnerCtaColor)
        ? `
        .partner-header-action {
          background-color: ${props?.partnerCtaColor} !important;
          border-color: ${props?.partnerCtaColor} !important;
        }
      `
        : ''
    }
    ${
      checkValue(ctaHoverBgColor)
        ? `
        .partner-header-action {
          &:hover {
            background-color: ${ctaHoverBgColor} !important;
            border-color: ${ctaHoverBgColor} !important;
            filter: ${checkValue(props?.partnerCtaHoverColor) ? `brightness(1);` : `brightness(0.8);`} 
          }
        }
      `
        : ''
    }
    ${
      checkValue(ctaHoverFontColor)
        ? `
        .partner-header-action {
          &:hover {
            color: ${ctaHoverFontColor} !important;
          }
        }
      `
        : ''
    }
    ${checkValue(props?.partnerCtaTextColor) ? `color: ${props?.partnerCtaTextColor} !important;` : ``}
    ${
      !checkValue(props?.partnerCtaColor) && props?.partnerHeaderTextColor?.toLowerCase() === 'dark'
        ? `
      .partner-header-action {
        &:hover {
          background-color: #141D38 !important;
          border-color: #141D38 !important;
          color: #fff !important;
        }
      }
      `
        : ''
    } 
    `;
  };

  const logoOnclick = () => {
    const { gaTracking, href, target } = headerBrandLogoProps;
    const { eventCategory, eventAction, eventLabel } = gaTracking;
    gaLogger.logGa(eventCategory, eventAction, eventLabel);
    if (href) {
      if (target === '') {
        window.location.href = href;
      } else {
        window.open(href, target);
      }
    }
  };

  const setPartnerHeaderText = () => {
    if (checkValue(props?.partnerMessageUrl)) {
      return (
        <a
          href={props?.partnerMessageUrl}
          className={`partner-header-message ${
            !checkValue(props?.partnerLogo) && !checkValue(props?.partnerName) && !checkValue(props?.partnerCtaText)
              ? 'show-partner-text'
              : ''
          }`}
        >
          {props?.partnerMessage}
        </a>
      );
    } else {
      return (
        <UitkText
          className={`partner-header-message ${
            !checkValue(props?.partnerLogo) && !checkValue(props?.partnerName) && !checkValue(props?.partnerCtaText)
              ? 'show-partner-text'
              : ''
          }`}
        >
          {props?.partnerMessage}
        </UitkText>
      );
    }
  };

  const setPartnerHeaderPlaceholderText = () => {
    if (checkValue(props?.partnerHeaderPlaceholderText) && checkValue(props?.partnerHeaderPlaceholderUrl)) {
      return (
        <UitkLink className={'partner-placeholder'}>
          <a href={props?.partnerHeaderPlaceholderUrl}>{props?.partnerHeaderPlaceholderText}</a>
        </UitkLink>
      );
    } else if (checkValue(props?.partnerHeaderPlaceholderText)) {
      return <UitkText className={'partner-placeholder'}>{props?.partnerHeaderPlaceholderText}</UitkText>;
    } else {
      return '';
    }
  };

  const lozengeMessageProps: LozengeMessageV2Props = {
    lozengeDetailMessage: props?.lozengeDetailMessage,
    backgroundColor: checkValue(props?.lozengeBackgroundColor)
      ? props?.lozengeBackgroundColor
      : props?.partnerHeaderBackgroundColor,
    color: props?.lozengeTextColor,
    defaultTextColor: props?.partnerHeaderTextColor,
    exClass: !checkValue(props?.partnerLogo) && !checkValue(props?.partnerName) ? 'left-margin-0' : '',
    iconStyle: props?.lozengeIconStyle,
    iconColor: props?.lozengeIconColor,
  };

  //--------- delay load simple menu and subleavel menu -------------
  const [loadMenus, setLoadMenus] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoadMenus(true);
    }, 950);

    return () => clearTimeout(timer); // Cleanup function to clear the timer on unmount
  }, []);

  //--------- delay load simple menu and subleavel menu -------------

  const simpleMenuEnabledClass =
    props?.isHamburgerMenu && subHeaderMenuPosition === 'Right' ? 'simple-menu-enabled' : '';
  const hamburgerMenuEnabledClass =
    props?.isHamburgerMenu && subHeaderMenuPosition !== 'Right' ? 'hamburger-enable' : '';
  const subLevelMenuEnabledClass = checkValue(partnerHeaderSubNavigation, true) ? 'sublevel-menu-enabled' : '';

  return (
    <Layout
      HtmlTag="div"
      className="partner-header-region"
      css={css`
        ${moduleCss()}
      `}
    >
      <div
        className={`partner-header ${
          checkValue(props?.partnerHeaderSize) ? `partner-header-logo-${props?.partnerHeaderSize}` : ''
        } ${props?.isHeaderTurnOff ? `no-priamary-site-header` : ''}`}
      >
        {props?.isHamburgerMenu && subHeaderMenuPosition !== 'Right' && <BurgerMenu />}
        <div
          className={`partner-logo-container ${
            !checkValue(props?.partnerUrl) ? 'no-link' : ''
          } ${simpleMenuEnabledClass} ${hamburgerMenuEnabledClass} ${subLevelMenuEnabledClass}`}
        >
          {/* Gatracking and href overide to false and onclick is move to parent div */}
          {checkValue(props?.partnerLogo) ? (
            <HeaderBrandLogo {...{ ...headerBrandLogoProps, gaTracking: undefined, href: false }} />
          ) : (
            checkValue(props?.partnerHeaderPlaceholderText) && setPartnerHeaderPlaceholderText()
          )}
          {/* {checkValue(props?.partnerName) && (
            <UitkText className={`partner-name ${!checkValue(props?.partnerLogo) ? 'no-margin' : ''}`}>
              {props?.partnerName}
            </UitkText>
          )} */}
          <LozengeMessageV2 {...lozengeMessageProps} />
        </div>
        <div
          className={`action-item-container ${simpleMenuEnabledClass} ${hamburgerMenuEnabledClass} ${subLevelMenuEnabledClass}`}
        >
          {/* {loadMenus && (
            <> */}
              {props?.isHamburgerMenu && subHeaderMenuPosition === 'Right' && <SiimpleMenu  loadMenus={loadMenus}/>}
              {checkValue(partnerHeaderSubNavigation, true) && <SubLevelMenu loadMenus={loadMenus} />}
            {/* </>
          )} */}
          {props?.partnerMessage && setPartnerHeaderText()}
          {checkValue(props?.partnerCtaText) && <SecondaryButton {...secondaryButtonProps} />}
        </div>
      </div>
    </Layout>
  );
};

export default SubHeader;
